 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","BdManage~Blacklist~bdAdd~goodsList~pkEdit~pkEditAlreadyRelease":"BdManage~Blacklist~bdAdd~goodsList~pkEdit~pkEditAlreadyRelease","BdManage":"BdManage","Blacklist":"Blacklist","bdAdd":"bdAdd","pkEditAlreadyRelease":"pkEditAlreadyRelease","Cmsbanner~adminAppTest~config~decoration~extension":"Cmsbanner~adminAppTest~config~decoration~extension","Cmsbanner":"Cmsbanner","config~decoration~goodsList~pkEdit":"config~decoration~goodsList~pkEdit","adminAppTest~decoration~extension":"adminAppTest~decoration~extension","decoration":"decoration","CustomText":"CustomText","Home~extension":"Home~extension","Home":"Home","Message":"Message","adminAppTest~appAdminManage~config~extension~goodsList~myCenter~pkEdit":"adminAppTest~appAdminManage~config~extension~goodsList~myCenter~pkEdit","config~pkEdit":"config~pkEdit","pkEdit":"pkEdit","goodsList":"goodsList","extension":"extension","adminAppTest":"adminAppTest","config":"config","appAdminManage":"appAdminManage","myCenter":"myCenter","adminHome":"adminHome","commission":"commission","consumptionList":"consumptionList","extension.activate":"extension.activate","extension.food":"extension.food","extension.taxi":"extension.taxi","filter":"filter","finance":"finance","helpManage~noticeManage":"helpManage~noticeManage","helpManage":"helpManage","noticeManage":"noticeManage","invitation":"invitation","kzManage":"kzManage","layout":"layout","myCenterRechange":"myCenterRechange","overview":"overview","pidManage":"pidManage","pkEditAwaitRelease":"pkEditAwaitRelease","tuiCoin":"tuiCoin","upgrade":"upgrade","userList":"userList","userManageList":"userManageList","userManageLower":"userManageLower"}[chunkId]||chunkId) + "." + {"404":"d6698c57","BdManage~Blacklist~bdAdd~goodsList~pkEdit~pkEditAlreadyRelease":"2b69bfd7","BdManage":"76a82145","Blacklist":"c5256fbd","bdAdd":"da8c8198","pkEditAlreadyRelease":"8c406733","Cmsbanner~adminAppTest~config~decoration~extension":"a44e9f8a","Cmsbanner":"386d928d","config~decoration~goodsList~pkEdit":"6e457ccf","adminAppTest~decoration~extension":"cbe14c49","decoration":"868245c3","CustomText":"91deecda","Home~extension":"33ae5fe9","Home":"bf86684a","Message":"e25cf5c2","adminAppTest~appAdminManage~config~extension~goodsList~myCenter~pkEdit":"5d474b64","config~pkEdit":"f83f13d0","pkEdit":"b0807579","goodsList":"18970111","extension":"80bacde4","adminAppTest":"fc860928","config":"df067669","appAdminManage":"c84ca140","myCenter":"63506128","adminHome":"2215ee4b","commission":"4bf8f6a4","consumptionList":"5fd4de49","extension.activate":"3c905dac","extension.food":"8f937d43","extension.taxi":"8b4438ee","filter":"252406d3","finance":"f55d4f7a","helpManage~noticeManage":"82f8130b","helpManage":"dafa587b","noticeManage":"93086d5a","invitation":"21ef9fd1","kzManage":"31af40e2","layout":"de565d66","myCenterRechange":"8395f21e","overview":"263c7d94","pidManage":"0b7f0267","pkEditAwaitRelease":"e2d2b2d3","tuiCoin":"70b2399a","upgrade":"b5609938","userList":"98c8712c","userManageList":"5847c4cc","userManageLower":"8fe2b0a3"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"404":1,"BdManage~Blacklist~bdAdd~goodsList~pkEdit~pkEditAlreadyRelease":1,"BdManage":1,"Blacklist":1,"bdAdd":1,"pkEditAlreadyRelease":1,"Cmsbanner~adminAppTest~config~decoration~extension":1,"Cmsbanner":1,"decoration":1,"CustomText":1,"Home~extension":1,"Home":1,"Message":1,"config~pkEdit":1,"pkEdit":1,"goodsList":1,"extension":1,"adminAppTest":1,"config":1,"appAdminManage":1,"myCenter":1,"adminHome":1,"commission":1,"consumptionList":1,"extension.activate":1,"extension.food":1,"extension.taxi":1,"filter":1,"finance":1,"helpManage~noticeManage":1,"helpManage":1,"noticeManage":1,"invitation":1,"kzManage":1,"layout":1,"myCenterRechange":1,"overview":1,"pidManage":1,"pkEditAwaitRelease":1,"tuiCoin":1,"upgrade":1,"userList":1,"userManageList":1,"userManageLower":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"404":"404","BdManage~Blacklist~bdAdd~goodsList~pkEdit~pkEditAlreadyRelease":"BdManage~Blacklist~bdAdd~goodsList~pkEdit~pkEditAlreadyRelease","BdManage":"BdManage","Blacklist":"Blacklist","bdAdd":"bdAdd","pkEditAlreadyRelease":"pkEditAlreadyRelease","Cmsbanner~adminAppTest~config~decoration~extension":"Cmsbanner~adminAppTest~config~decoration~extension","Cmsbanner":"Cmsbanner","config~decoration~goodsList~pkEdit":"config~decoration~goodsList~pkEdit","adminAppTest~decoration~extension":"adminAppTest~decoration~extension","decoration":"decoration","CustomText":"CustomText","Home~extension":"Home~extension","Home":"Home","Message":"Message","adminAppTest~appAdminManage~config~extension~goodsList~myCenter~pkEdit":"adminAppTest~appAdminManage~config~extension~goodsList~myCenter~pkEdit","config~pkEdit":"config~pkEdit","pkEdit":"pkEdit","goodsList":"goodsList","extension":"extension","adminAppTest":"adminAppTest","config":"config","appAdminManage":"appAdminManage","myCenter":"myCenter","adminHome":"adminHome","commission":"commission","consumptionList":"consumptionList","extension.activate":"extension.activate","extension.food":"extension.food","extension.taxi":"extension.taxi","filter":"filter","finance":"finance","helpManage~noticeManage":"helpManage~noticeManage","helpManage":"helpManage","noticeManage":"noticeManage","invitation":"invitation","kzManage":"kzManage","layout":"layout","myCenterRechange":"myCenterRechange","overview":"overview","pidManage":"pidManage","pkEditAwaitRelease":"pkEditAwaitRelease","tuiCoin":"tuiCoin","upgrade":"upgrade","userList":"userList","userManageList":"userManageList","userManageLower":"userManageLower"}[chunkId]||chunkId) + "." + {"404":"564046c9","BdManage~Blacklist~bdAdd~goodsList~pkEdit~pkEditAlreadyRelease":"087cfab2","BdManage":"ade7e563","Blacklist":"305581d4","bdAdd":"4d1f6679","pkEditAlreadyRelease":"36a7e1e1","Cmsbanner~adminAppTest~config~decoration~extension":"a803130a","Cmsbanner":"8e568238","config~decoration~goodsList~pkEdit":"31d6cfe0","adminAppTest~decoration~extension":"31d6cfe0","decoration":"47cf1073","CustomText":"9d2b0628","Home~extension":"f634f809","Home":"6124b2ab","Message":"c17e793c","adminAppTest~appAdminManage~config~extension~goodsList~myCenter~pkEdit":"31d6cfe0","config~pkEdit":"f1e3665d","pkEdit":"ed8638e4","goodsList":"3e8870a7","extension":"3b75bf50","adminAppTest":"bcf648d2","config":"05b38ecd","appAdminManage":"5d52b463","myCenter":"9311f380","adminHome":"1ffa354a","commission":"be425f24","consumptionList":"e3c0e8cd","extension.activate":"87c8b0ac","extension.food":"11bf4f64","extension.taxi":"11bf4f64","filter":"33c08653","finance":"1e1cd786","helpManage~noticeManage":"0e433876","helpManage":"c4af02b9","noticeManage":"fa97fe88","invitation":"8870cfe2","kzManage":"5d32ce73","layout":"1b4e2dad","myCenterRechange":"4b24b476","overview":"f524abe3","pidManage":"225bcf98","pkEditAwaitRelease":"3ea19371","tuiCoin":"e66b9294","upgrade":"8edbb1a7","userList":"0f94da77","userManageList":"9bfabef9","userManageLower":"49329e5e"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/promote/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
